import {
  authBrandingSectionSx,
  authBrandingContentSx,
  authBrandingLogoRowSx,
  authBrandingHeroSectionSx,
  authBrandingHeadlineSx,
  authBrandingDescriptionSx,
  authBrandingFeatureListSx,
  authBrandingFeatureItemSx,
  authBrandingFeatureIconSx,
  authBrandingFeatureTextSx,
  authBrandingCopyrightSx,
  authLayoutContainerSx,
  authFormSectionSx,
  authDesktopLanguageSwitcherSx,
  authFormWrapperSx,
  authMobileHeaderSx,
  authMobileLogoRowSx,
  authFormCardSx,
} from 'components/styles/auth';
import { linkSx } from 'components/styles/link';
import { Box, Typography } from 'components/ui';
import { CheckIcon } from 'components/uiIcons';
import { Suspense } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from 'utils/authentication';
import { WebsiteLink, DashboardLink } from 'utils/link';
import SwitchComponent from 'components/internationalization_switch';
import Loader from 'components/layout/loader';
import Logo from 'components/layout/logo';

const features = ['auth.landing.feature1', 'auth.landing.feature2', 'auth.landing.feature3'];

const BrandingPanel = () => (
  <Box sx={authBrandingSectionSx}>
    <Box sx={authBrandingContentSx}>
      <Box sx={authBrandingLogoRowSx}>
        <Box component={Link} sx={linkSx} to={WebsiteLink()}>
          <Logo width={40} />
        </Box>
      </Box>
      <Box sx={authBrandingHeroSectionSx}>
        <Typography sx={authBrandingHeadlineSx} variant="h2">
          <FormattedMessage id="auth.landing.headline" />
        </Typography>
        <Typography sx={authBrandingDescriptionSx}>
          <FormattedMessage id="auth.landing.description" />
        </Typography>
        <Box sx={authBrandingFeatureListSx}>
          {features.map((featureId) => (
            <Box sx={authBrandingFeatureItemSx} key={featureId}>
              <Box sx={authBrandingFeatureIconSx}>
                <CheckIcon />
              </Box>
              <Typography sx={authBrandingFeatureTextSx}>
                <FormattedMessage id={featureId} />
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Typography sx={authBrandingCopyrightSx}>
        <FormattedMessage id="footer.copyright" values={{ year: new Date().getFullYear() }} />
      </Typography>
    </Box>
  </Box>
);

const PublicAuthRoute = () => {
  if (isAuthenticated()) {
    return <Navigate to={DashboardLink()} />;
  }

  return (
    <Box sx={authLayoutContainerSx}>
      <BrandingPanel />
      <Box sx={authFormSectionSx}>
        <Box sx={authDesktopLanguageSwitcherSx}>
          <SwitchComponent />
        </Box>
        <Box sx={authFormWrapperSx}>
          <Box sx={authMobileHeaderSx}>
            <Box sx={authMobileLogoRowSx}>
              <Box component={Link} sx={linkSx} to={WebsiteLink()}>
                <Logo width={40} />
              </Box>
            </Box>
            <SwitchComponent />
          </Box>
          <Box sx={authFormCardSx}>
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PublicAuthRoute;
